<template>
	<div class="loop-container" :class="{'full': full, 'horizontal': horizontal}">
		<div class="item w-full md:w-1/4 lg:w-1/5 flex-shrink-0" v-for="item in reactiveItems">
			<a v-bind:href="item.sponsor_website" target="_blank" rel="noreferrer">
        <img v-bind:src="item.logo.url" v-bind:alt="item.title" class="h-24 object-contain mx-auto px-1" />
      </a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VueLoop',
	/**
	 * Define props
	 */

	props: {
		full: {
			type: Boolean,
			default: true
		},
		horizontal: {
			type: Boolean,
			default: false
		},
		items: {
			type: Array,
			default: null
		}
	},
	/**
	 * Initialize default data
	 *
	 * @return {object}
	 */

	data() {
		return {
			pageHeight: 0,
			viewportHeight: 0,
			pageWidth: 0,
			viewportWidth: 0,
			duplicates: false,
			isTouch: false,
			reactiveItems: this.items
		}
	},
	/**
	 * When the component is mounted
	 */

	mounted() {
		const vm = this;

		//When the window has loaded we're going to work out the dimensions
		window.addEventListener('load', () => {
			vm.getDimensions(), vm.autoScroll()
		});

		//When the window is resized we want to re-calculate the dimensions
		window.addEventListener('resize', () => {
			vm.getDimensions()
		}, true);
	},
	methods: {
		autoScroll() {
			const container = this.$el;
			const vm = this;
			var self = this;
			setInterval(function(){
				var x = container.scrollLeft;
				if(x == (vm.pageWidth - 1))
				{
					container.scrollLeft = 0;
				}
				else if(x > (vm.pageWidth - 1))
				{
					container.scrollLeft = x;
				}
				else {
					container.scrollLeft += 1;
				}
			}, 10);
		},

		/**
		 * Get dimensions of the page and viewport
		 */
		getDimensions() {
			const vm = this;
			const container = vm.$el;
			var numOfItems = this.items.length;
			if(vm.duplicates === true)
			{
				numOfItems = numOfItems / 2;
			}
			if(vm.duplicates === false) {
				vm.duplicates = vm.makeDuplicates();
			}
			vm.pageWidth = 0;
			for(var i = 0; i < numOfItems; i++) {
				const itemWidth = container.querySelectorAll('.item')[i].clientWidth;
				vm.pageWidth += itemWidth;
			}
			vm.viewportWidth = container.clientWidth;
		},

		/**
		 * Make duplicates so the scroll is smooth
		 */
		makeDuplicates() {
			var length = this.items.length;
			for(var i = 0; i < length; i++)
			{
				var item = this.items[i];
				this.reactiveItems.push(item);
			}
			return true;
		}
	}
}
</script>

<style>
.loop-container {
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
}
.loop-container.full {
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-items: stretch;
	justify-content: flex-start;
	position: absolute;
	top: 0px;
	bottom: 0px;
	left: 0px;
	right: 0px;
}
.loop-container.full > .item {
	min-width: 100%;
	min-height: 100%;
	flex: 1;
	backface-visibility: hidden;
    transform: translate3d(0,0,0);
}
.loop-container.horizontal {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	overflow-y: hidden;
	overflow-x: scroll;
	min-height: 100px;
	max-height: 150px;
	max-width: 80%;
	margin: 20px auto;
	scrollbar-width: none;
}
.loop-container.horizontal::-webkit-scrollbar {
	display: none;
	}

.loop-container.horizontal > .item {
}
.loop-container.full.horizontal > .item {
	min-width: 100%;
	flex: 1;
}
</style>